import React, { useState, useEffect, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Loader, Text, Stack, Group, LoadingOverlay } from "@mantine/core";
import { IconX, IconCheck } from "@tabler/icons-react";
import useStatusCheck from "../../../hooks/useStatusCheck";
import useEdgeStatusCheck from "../../../hooks/useEdgeStatusCheck";
import { DataContext } from "../../../context/DataContext";
const OneIdReturn = () => {
  const { settings, data } = useContext(DataContext);
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("PENDING");
  const [loading, setLoading] = useState(true);

  // Detect edge mode from state parameter (contains "-edge" suffix for edge requests)
  const stateParam = searchParams.get("state");
  const isEdgeModeFromState = stateParam?.endsWith("-edge");
  const isEdgeMode = data?.edge === true || isEdgeModeFromState;
  
  useStatusCheck(!isEdgeMode, false, "idmax");
  useEdgeStatusCheck(isEdgeMode);

  useEffect(() => {
    const fetchStatus = async () => {
      setLoading(true);

      // Extract the actual request_id from state (remove "-edge" suffix if present)
      const actualRequestId = isEdgeModeFromState ? stateParam.replace("-edge", "") : stateParam;
      
      const requestData = {
        ...data,
        request_id: actualRequestId || settings.request_id,
        code: searchParams.get("code"),
        isIDMaxContinue: true,
        provider: "ONEID",
      };

      try {
        // Check if edge mode is enabled
        let apiUrl;
        let finalRequestData = { ...requestData };
        
        if (isEdgeMode) {
          // In edge mode, call the edge retrieve endpoint with just request_id and code
          const retrieveData = {
            request_id: actualRequestId,
            code: searchParams.get("code")
          };
          
          try {
            console.log("Calling edge retrieve with auth data:", retrieveData);
            const retrieveResponse = await fetch("https://dcams.app/edge/backend/api/idmax/retrieve", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(retrieveData),
            });
            
            if (retrieveResponse.ok) {
              const result = await retrieveResponse.json();
              console.log("Edge retrieve response:", result);
              setStatus(result.status || "SUCCESS");
              setLoading(false);
              return; // Don't proceed to queue processing
            } else {
              console.error("Edge retrieve failed:", retrieveResponse.status, retrieveResponse.statusText);
              throw new Error(`Edge retrieve failed: ${retrieveResponse.status}`);
            }
          } catch (retrieveError) {
            console.error("Error calling edge retrieve:", retrieveError);
            setStatus("ERROR");
            setLoading(false);
            return;
          }
        } else {
          // Normal mode - use regular backend
          apiUrl = process.env.REACT_APP_BACKEND_URL + "/v3/stable/api/frontend/idmax";
          
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(finalRequestData),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data_returned = await response.json();
          console.log("Return response:", data_returned);

          setStatus(data_returned.status || "SUCCESS");
        }
      } catch (error) {
        console.error("Error fetching status:", error);
        setStatus("ERROR"); // or a more descriptive error message
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [searchParams]);

  useEffect(() => {
    // Attempt to close the current tab after OneID verification completes
    if (status === "PENDING") {
      return;
    }
    window.close();
  }, [status]);

  return <LoadingOverlay visible />;
};

export default OneIdReturn;
